import styled from 'styled-components';

export const ProductImageBackground = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-image: ${props => (props.backGroundImg ? `url("${props.backGroundImg}")` : 'none')};
  background-size: cover;
  background-position: center;
`;



// WEBPACK FOOTER //
// ./src/styles/ProductImageBackground.js